import router from '~/core/router';
import { JustdoneOnboardingExperimentRoute } from '~/projects/justdone/onboardingExperiment';

router.addPrivateRoutes([JustdoneOnboardingExperimentRoute]);
